require.register("ffss/component/Carousel", function(exports, require, module){
  $0
  
});

